import React, { memo } from 'react';
import { buildMutationRows, mutationTypes } from './mutationUtils';
import { Card, CardContent, CardHeader, List, ListItem, ListItemText } from '@mui/material';
import BtnOpenMutation from './BtnOpenMutation';

export const WORD_TEMPLATE = '__word__';

const MutationSentences = ({ sentences, word }) => {

  const { rows, hasMutations } = buildMutationRows(sentences, word);

  return (
    <Card>
      <CardContent>
        <CardHeader
          title={'Sentences'}
          action={
            <>
              {hasMutations.spirante && <BtnOpenMutation mutationType={mutationTypes.SPIRANTE} />}
              {hasMutations.hard && <BtnOpenMutation mutationType={mutationTypes.HARD} />}
              {hasMutations.mixed && <BtnOpenMutation mutationType={mutationTypes.MIXED} />}
              {hasMutations.soft && <BtnOpenMutation mutationType={mutationTypes.SOFT} />}
            </>
          } />

        <List className={'mutation-sentences'}>
          {rows.map((row, idx) => {

            const fmtResult = `<em class="${row.hasMutated ? row.rowHeader.mutationType : ''}">${row.result}</em>`;

            return (
              <ListItem key={idx}>
                <ListItemText primary={<span dangerouslySetInnerHTML={{ __html: row.rowHeader.sentence.replace(WORD_TEMPLATE, fmtResult) }}></span>} />
              </ListItem>
            );
          })}
        </List>
      </CardContent>
    </Card>
  );
};

export default memo(MutationSentences);
